var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel-content',{staticClass:"expansion-panel-content",attrs:{"disabled":_vm.disabled,"expand-icon":_vm.expandIcon}},[_vm._t("header",null,{"slot":"header"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }